// Player Vimeo zapisuje magazyn marketingowy (orionV3, picox) i statystyczny (vuid) — start dopiero po zgodzie w Consent Mode v2
const REQUIRED = ['ad_storage', 'analytics_storage'];

const dataLayer = window.dataLayer = window.dataLayer || [];
const consent = { default: {}, update: {} };
const listeners = [];
let consentMode = false;

// strona bez komend consent (sklep bez Consent Mode) ładuje wideo jak dawniej
export const vimeoAllowed = () => !consentMode || REQUIRED.every(key => (consent.update[key] ?? consent.default[key]) === 'granted');

export const onVimeoAllowed = (callback) => listeners.push(callback);

const track = (entry) => {
    if (!entry || entry[0] !== 'consent' || (entry[1] !== 'default' && entry[1] !== 'update') || !entry[2]) return false;
    Object.assign(consent[entry[1]], entry[2]);
    consentMode = true;
    return true;
};

dataLayer.forEach(track);

// GTM podpina własny push, ale woła poprzedni — kolejność ładowania nie ma znaczenia
const push = dataLayer.push;
dataLayer.push = function () {
    const result = push.apply(dataLayer, arguments);
    if ([...arguments].map(track).some(Boolean) && vimeoAllowed()) listeners.forEach(callback => callback());
    return result;
};
